import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const updateFacilityRuleMutationAtom = createMutationAtomFactory(
  'settings.complianceFacilityRuleUpdate',
  (params: {
    id: string;
    isEnabled?: boolean;
    configuredValue?: { value: string | number | boolean };
    applicableCategoryIds?: string[];
    effectiveFrom?: string;
    effectiveTo?: string;
    notes?: string;
  }) => ({
    complianceComplianceFacilityRuleUpdate: {
      __args: {
        id: params.id,
        input: {
          isEnabled: params.isEnabled,
          configuredValue: params.configuredValue,
          applicableCategoryIds: params.applicableCategoryIds,
          effectiveFrom: params.effectiveFrom,
          effectiveTo: params.effectiveTo,
          notes: params.notes,
        },
      },
      id: true,
    },
  }),
);
